import { PropsWithChildren, useEffect, useState } from "react";
import { useLocation } from "react-router";

import MobileLayoutContext from "./MobileLayoutContext";

export default function MobileLayoutContextProvider({ children }: PropsWithChildren<unknown>) {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const { pathname } = useLocation();

    // biome-ignore lint/correctness/useExhaustiveDependencies: pathname is intentionally the only dep — it triggers the close on navigation
    useEffect(() => {
        setIsMenuOpen(false);
    }, [pathname]);

    return <MobileLayoutContext.Provider value={{ isMenuOpen, setIsMenuOpen }}>{children}</MobileLayoutContext.Provider>;
}
